import { Component, OnInit, Input, Output, EventEmitter, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-empty-error',
  templateUrl: './message-empty-error.component.html',
  styleUrls: ['./message-empty-error.component.scss'],
})
export class MessageEmptyErrorComponent implements OnInit {
  @Input() messageError: Array<any> = [];
  @Output() retryDataError = new EventEmitter<string>();

  constructor(
    @Optional() public readonly dialogRef?: MatDialogRef<MessageEmptyErrorComponent>  // ✅ Cambiado aquí
  ) {}

  ngOnInit() {
  }

  buttonRetry($event: any) {
    if ($event == 'Reintentar') {
      this.retryDataError.emit();
    }
    if (this.messageError[0]?.iconX) {
      this.exit();
    }
  }

  exit() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close('Entendido');
    }
  }
}
